import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<path fill=\"#ed2939\" d=\"M0 0h640v480H0z\"></path><path fill=\"#fff\" d=\"M180 0h120v480H180z\"></path><path fill=\"#fff\" d=\"M0 180h640v120H0z\"></path><path fill=\"#002664\" d=\"M210 0h60v480h-60z\"></path><path fill=\"#002664\" d=\"M0 210h640v60H0z\"></path>", 5)
  ]))]))
}
export default { render: render }